document.addEventListener("DOMContentLoaded", function () {
  const sliders = document.querySelectorAll(".swiper");

  sliders.forEach((slider) => {
    // ❌ Ignore les sliders déjà initialisés
    if (slider.classList.contains("swiper-initialized")) return;

    const slides = slider.querySelectorAll(".swiper-slide");
    const shouldLoop = slides.length >= 3;

    new Swiper(slider, {
      loop: shouldLoop,
      slidesPerView: 1,
      spaceBetween: 16,
      autoHeight: true,
      pagination: {
        el: slider.querySelector(".swiper-pagination"),
        clickable: true,
      },
      navigation: {
        nextEl: slider.querySelector(".swiper-button-next"),
        prevEl: slider.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
    });
  });
});
